module.exports = __webpack_public_path__ + "assets/img/sssb.077ad380.svg";